export type TimeRangeIssueCode =
  | 'START_AND_END_REQUIRED'
  | 'START_REQUIRED'
  | 'END_REQUIRED'
  | 'START_AFTER_END';

export type TimeRangeIssue = {
  field: 'start' | 'end' | 'range';
  severity: 'error';
  code: TimeRangeIssueCode;
};

export function validateTimeRange(
  start: Date | null,
  end: Date | null
): TimeRangeIssue[] {
  const issues: TimeRangeIssue[] = [];

  if (!start && !end) {
    issues.push({ field: 'range', severity: 'error', code: 'START_AND_END_REQUIRED' });
  }

  if (!start) {
    issues.push({ field: 'start', severity: 'error', code: 'START_REQUIRED' });
  }

  if (!end) {
    issues.push({ field: 'end', severity: 'error', code: 'END_REQUIRED' });
  }

  if (start && end && start >= end) {
    issues.push({
      field: 'range',
      severity: 'error',
      code: 'START_AFTER_END',
    });
  }

  return issues;
}
